<template>
  <div>
    <br />
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for="fullName"
            >Nom complet <span class="text-danger">*</span></label
          >
          <input
            type="text"
            class="form-control"
            id="fullName"
            v-model="society.fullName"
          />
        </div>
      </div>

      <div class="col-md-3">
        <div class="form-group">
          <label for="logo"> Logo </label>
          <input
            type="file"
            class="form-control"
            id="logo"
            name="logo"
            @change="onFileChange"
            accept="image/*"
          />
          <img
            v-if="imageUrl || society.logo"
            :src="imageUrl || $imageUrl(society.logo)"
            class="mt-2"
            style="max-width: 100px; max-height: 100px"
          />
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label for="capitalization">Capitalisation</label>
          <input
            type="number"
            step="0.01"
            class="form-control"
            id="capitalization"
            v-model="society.capitalization"
          />
        </div>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for="address">Adresse : </label>
          <input
            type="text"
            class="form-control"
            id="address"
            v-model="society.address"
          />
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label for="city">Ville</label>
          <input
            type="text"
            class="form-control"
            id="city"
            v-model="society.city"
          />
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label for="postalCode">Code postal</label>
          <input
            type="text"
            class="form-control"
            id="postalCode"
            v-model="society.zipCode"
          />
        </div>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <label for="phoneNumberA">Téléphone (1)</label>
          <input
            type="text"
            class="form-control"
            id="phoneNumberA"
            v-model="society.phoneA"
          />
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label for="phoneNumberB">Téléphone (2)</label>
          <input
            type="text"
            class="form-control"
            id="phoneNumberB"
            v-model="society.phoneNumberB"
          />
        </div>
      </div>

      <div class="col-md-3">
        <div class="form-group">
          <label for="fax">Fax</label>
          <input
            type="text"
            class="form-control"
            id="fax"
            v-model="society.fax"
          />
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label for="cnss">Numéro CNSS</label>
          <input
            type="text"
            class="form-control"
            id="cnss"
            v-model="society.cnss"
          />
        </div>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <label for="ice">Numéro ICE</label>
          <input
            type="text"
            class="form-control"
            id="ice"
            v-model="society.ice"
          />
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label for="rc">Numéro RC</label>
          <input
            type="text"
            class="form-control"
            id="rc"
            v-model="society.rc"
          />
        </div>
      </div>

      <div class="col-md-3">
        <div class="form-group">
          <label for="if">Numéro IF</label>
          <input
            type="text"
            class="form-control"
            id="if"
            v-model="society.if"
          />
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label for="tp">Numéro TP</label>
          <input
            type="text"
            class="form-control"
            id="tp"
            v-model="society.tp"
          />
        </div>
      </div>
    </div>

    <br />
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for="bank"> Banque </label>
          <input
            type="text"
            class="form-control"
            id="bank"
            v-model="society.bank"
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="rib">Nº RIB </label>
          <input
            type="text"
            class="form-control"
            id="rib"
            v-model="society.rib"
          />
        </div>
      </div>
    </div>

    <div class="row mt-3 justify-content-between">
      <div class="col-auto">
        <button
          @click="$router.push({ name: 'societies-index' })"
          class="btn btn-secondary"
        >
          <i class="bi bi-arrow-left"></i> Retour
        </button>
      </div>
      <div class="col-auto">
        <button @click="save(society)" class="btn btn-success">
          <i class="bi bi-check-square-fill"></i> Enregistrer
        </button>
      </div>
    </div>
    <br />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      image: null,
      imageUrl: null,
    };
  },
  computed: {
    ...mapGetters("society", {
      society: "getSociety",
    }),
  },
  mounted() {
    this.$store.dispatch("society/show", this.$route.params.reference);
  },
  methods: {
    async save(data) {
      let formData = new FormData();

      if (this.image) {
        formData.append("logo", this.image);
      }
      formData.append("reference", data.reference);
      formData.append("fullName", data.fullName || "");
      formData.append("capitalization", data.capitalization ? parseFloat(data.capitalization) : 0);
      formData.append("address", data.address || "");
      formData.append("city", data.city || "");
      formData.append("zipCode", data.zipCode || "");
      formData.append("phoneA", data.phoneA || "");
      formData.append("phoneNumberB", data.phoneNumberB || "");
      formData.append("fax", data.fax || "");
      formData.append("cnss", data.cnss || "");
      formData.append("ice", data.ice || "");
      formData.append("rc", data.rc || "");
      formData.append("if", data.if || "");
      formData.append("tp", data.tp || "");
      formData.append("bank", data.bank || "");
      formData.append("rib", data.rib || "");

      await this.$store.dispatch("society/update", {
        reference: data.reference,
        formData,
      });
    },
    async refresh() {
      await this.$store.dispatch("society/show", this.$route.params.reference);
    },
    onFileChange(e) {
      const file = e.target.files[0];
      if (file) {
        this.image = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageUrl = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
  },
};
</script>
